export const BOOSTING_FEE_OLD = 0.08;
export const BOOSTING_FEE = 0.12;
export const BOOSTED_SPACING = '4';
export const BOOSTED_GROUP_SIZE = '1';
export const BOOSTED_TEXT_ANY_LOCALE = 'Boosted';
export const BOOST_LISTINGS_MIN_ACCOUNT_AGE_IN_DAYS = 28;
